<template>
  <div class="modal fade modal-noborder modal-loginIn" tabindex="-1" role="dialog" id="Modal_login">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"><i class="icon-close"></i></button>
          <h4 class="modal-title fs24">印箱云打印登录</h4>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-lg-6 col-sm-6">
              <label>
                <span class="fs16">请输入手机号</span>
                <input v-on:input="inputMobile" :class="{ 'input-warning': isMobileError }" v-model="mobile" class="form-control" type="text" placeholder="手机号" value="123123">
                <span v-show="isError" class="text-warning">{{ errorMsg }}</span>
              </label>
            </div>
            <div class="col-lg-6 col-sm-6">
              <label>
                <span class="fs16">验证码</span>
                <input v-on:input="inputCheckcode" :class="{ 'input-warning': isCodeError }" v-model="checkcode" class="form-control" type="text" placeholder="验证码" value="123">
                <span class="pointer checkcode-trigger" @click="getCheckCode">
                                    <template v-if="canGet">获取验证码</template>
                                    <template v-else>{{ countTime }} s</template>
                                </span>
              </label>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <span class="btn btn-opt" @click="submit">登 录</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {ajax} from '@/api/global'

  export default {
    name: "ModalLogin",
    props: [],
    data: function () {
      return {
        mobile : '',
        checkcode : '',
        isMobileError : false,
        isCodeError : false,
        isError : false,
        errorMsg : '',
        canGet : true,
        countTime : 0
      }
    },
    methods: {
      inputMobile : function () {
        this.isMobileError = false;
        self.isError = false;
      },
      inputCheckcode : function () {
        this.isCodeError = false;
        self.isError = false;
      },
      countDown : function () {
        var self = this;
        self.countTime = 60;
        var callback = function () {
          setTimeout(function () {
            if (self.countTime > 1) {
              self.countTime = self.countTime - 1;
              callback();
            } else {
              self.canGet = true;
              self.countTime = self.limitTime;
            }
          }, 1000);
        };
        callback();
      },
      getCheckCode : function () {
        var self = this;
        if (!self.canGet) {
          return false;
        }
        self.canGet = false;
        self.countDown();
        ajax({
          // mock : Mock.getCheckcode,
          urlext : 'mobile',
          url : 'api/auth/jwt/sendSmsCode',
          type : 'post',
          data : {
            phone : self.mobile
          },
          success : function (res) {
            alert('验证码已发送, 请查收!');
            // self.alertSuccess('验证码已发送, 请查收!');
            // this.$vDialog.alert('验证码已发送, 请查收!',null, {messageType: 'success'});
          },
          fail : function (res) {
            self.isError = true;
            self.errorMsg = res.message;
          }
        });
      },
      submit : function () {
        var self = this;
        if (!self.mobile) {
          self.isMobileError = true;
          self.isError = true;
          self.errorMsg = '手机号不能为空';
          return false;
        } else if(!/(^(([0\+]\d{2,3}-)?(0\d{2,3})-)(\d{7,8})(-(\d{3,}))?$)|(^0{0,1}1[3|4|5|6|7|8|9][0-9]{9}$)/.test(self.mobile)) {
          self.isMobileError = true;
          self.isError = true;
          self.errorMsg = '手机号格式不正确';
          return false;
        }
        if (!self.checkcode) {
          self.isCodeError = true;
          self.isError = true;
          self.errorMsg = '验证码不能为空';
          return false;
        }
        ajax({
          // mock : Mock.login,
          url : 'api/auth/jwt/loginPhone',
          type : 'post',
          data : {
            phone : self.mobile,
            smsCode : self.checkcode
          },
          success : function (res) {
            self.isError = false;
            console.log(res.data);
            self.$emit('login', res.data);
          },
          fail : function (res) {
            self.isError = true;
            self.errorMsg = res.message;
          }
        });
      }
    },
    created: function () {
      console.info('modal-login-init');
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ModalLogin.vue